import * as Sentry from "@sentry/react";

// `level` defaults to Sentry's "error". Pass "info" / "warning" for expected
// conditions we still want telemetry on but that are not defects (see
// domPatches.js) — Sentry ignores an undefined level, so existing callers are
// unaffected.
export function captureError(error, { tags, extra, level } = {}) {
    console.error(error);
    Sentry.captureException(error, { tags, extra, level });
}
